import React from 'react';

const postingsData = [
  { posting: "ALLERGIES", date: "" },
  { posting: "RES: RESEARCH ENROLMENT NOTE", date: "Jan 10, 2024 16:44" },
  { posting: "RES: RESEARCH ENROLMENT NOTE", date: "Dec 22, 2023 15:10" },
  { posting: "ADVANCE DIRECTIVE DISCUSSION", date: "Mar 15, 2017 15:22" }
];

const Postings = () => {
  return (
    <div style={{ borderRadius: 4, padding: 8, maxWidth: 600 }}>
      <div style={{ display: "flex", fontWeight: "bold", padding: "6px 0"}}>
        <div style={{ flex: 2, paddingLeft: 12}}>Posting</div>
        <div style={{ flex: 1 }}>Date</div>
      </div>
      <ul style={{ 
        listStyle: 'disc', 
        margin: 0, 
        padding: '0 0 0 20px',
        backgroundColor: '#fff'
      }}>
        {postingsData.map((row, idx) => (
          <li key={idx} style={{ 
            display: "flex", 
            listStyleType: 'disc',
            marginBottom: '4px'
          }}>
            <div style={{ flex: 2, color: "#1a73e8", fontWeight: "bold",fontSize:'12px' }}>{row.posting}</div>
            <div style={{ flex: 1, color: "#1a73e8", fontWeight: "bold" ,fontSize:'12px'}}>{row.date}</div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Postings;
